import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';
import { Mixpanel } from '../../Mixpanel';

const HackathonsHeader = () => {
  return (
    <div className='hackathons--header'>
      <div className='hackathons--title'>Найди хакатон своей мечты</div>
      <Link to="/add_hackathon" onClick ={() => Mixpanel.track('Hackathons', {'Button' : 'Add hackathon'})} className='btn'>+ Добавить хакатон</Link>
    </div>
  )
}

export default HackathonsHeader


// WEBPACK FOOTER //
// ./src/components/Hackathons/HackHeader/index.js